import { h as e } from "vue";
const o = (r) => () => e(
  r,
  {
    class: "h-4 w-4"
  },
  {}
);
export {
  o as renderIcon
};
